import requests from './request';


export const getNewsList=(page=1,page_size=20)=>requests({url:`/index/get_news_list?page=${page}&page_size=${page_size}`,method:"GET"})
export const getNews=(id)=>requests({url:`/index/get_news_detail?id=${id}`,method:"GET"})